export const getTranslations = (
  t: (key: string, defaultValue?: string) => string
) => ({
  categories: {
    organization: {
      title: t(
        "frontend.futurebilityCockpit.categories.organization.title",
        "Organization"
      ),
      hoverTitle: t(
        "frontend.futurebilityCockpit.categories.organization.hoverTitle",
        "Organization Hover"
      ),
      description: t(
        "frontend.futurebilityCockpit.categories.organization.description",
        "Description for Organization category."
      ),
    },
    team: {
      title: t("frontend.futurebilityCockpit.categories.team.title", "Team"),
      hoverTitle: t(
        "frontend.futurebilityCockpit.categories.team.hoverTitle",
        "Team Hover"
      ),
      description: t(
        "frontend.futurebilityCockpit.categories.team.description",
        "Description for Team category."
      ),
    },
    leadership: {
      title: t(
        "frontend.futurebilityCockpit.categories.leadership.title",
        "Leadership"
      ),
      hoverTitle: t(
        "frontend.futurebilityCockpit.categories.leadership.hoverTitle",
        "Leadership Hover"
      ),
      description: t(
        "frontend.futurebilityCockpit.categories.leadership.description",
        "Description for Leadership category."
      ),
    },
  },
  quadrantTitles: [
    t(
      "frontend.futurebilityCockpit.marketType4.quadrantTitle",
      "Type 4 dynamic-disruptive"
    ),
    t(
      "frontend.futurebilityCockpit.marketType2.quadrantTitle",
      "Type 2 dynamic-incremental"
    ),
    t(
      "frontend.futurebilityCockpit.marketType1.quadrantTitle",
      "Type 1 static-incremental"
    ),
    t(
      "frontend.futurebilityCockpit.marketType3.quadrantTitle",
      "Type 3 static-disruptive"
    ),
  ],
  quadrantTopHeadlines: [
    t(
      "frontend.futurebilityCockpit.marketType4.quadrantTopHeadline",
      "dynamic-disruptive"
    ),
    t(
      "frontend.futurebilityCockpit.marketType2.quadrantTopHeadline",
      "dynamic-incremental"
    ),
    t(
      "frontend.futurebilityCockpit.marketType1.quadrantTopHeadline",
      "static-incremental"
    ),
    t(
      "frontend.futurebilityCockpit.marketType3.quadrantTopHeadline",
      "static-disruptive"
    ),
  ],
  quadrantSidePanelTexts: [
    t(
      "frontend.futurebilityCockpit.marketType4.quadrantPanelDescription",
      "Type 4 panel description"
    ),
    t(
      "frontend.futurebilityCockpit.marketType2.quadrantPanelDescription",
      "Type 2 panel description"
    ),
    t(
      "frontend.futurebilityCockpit.marketType1.quadrantPanelDescription",
      "Type 1 panel description"
    ),
    t(
      "frontend.futurebilityCockpit.marketType3.quadrantPanelDescription",
      "Type 3 panel description"
    ),
  ],
  quadrantSidePanelTitles: [
    t(
      "frontend.futurebilityCockpit.marketType4.quadrantPanelTitle",
      "Type 4 panel title"
    ),
    t(
      "frontend.futurebilityCockpit.marketType2.quadrantPanelTitle",
      "Type 2 panel title"
    ),
    t(
      "frontend.futurebilityCockpit.marketType1.quadrantPanelTitle",
      "Type 1 panel title"
    ),
    t(
      "frontend.futurebilityCockpit.marketType3.quadrantPanelTitle",
      "Type 3 panel title"
    ),
  ],
  chartTitles: {
    yTopTitle: t(
      "frontend.futurebilityCockpit.marketTypeChart.yTopTitle",
      "dynamic"
    ),
    yCenterTitle: t(
      "frontend.futurebilityCockpit.marketTypeChart.yCenterTitle",
      "Dynamics"
    ),
    yBottomTitle: t(
      "frontend.futurebilityCockpit.marketTypeChart.yBottomTitle",
      "static"
    ),
    xLeftTitle: t(
      "frontend.futurebilityCockpit.marketTypeChart.xLeftTitle",
      "old Market - Incremental"
    ),
    xCenterTitle: t(
      "frontend.futurebilityCockpit.marketTypeChart.xCenterTitle",
      "Degree of innovation"
    ),
    xRightTitle: t(
      "frontend.futurebilityCockpit.marketTypeChart.xRightTitle",
      "new Market - Disruptive"
    ),
  },
});
